import { IAction, StateStatus } from 'redux/utils/common';
import * as Types from './type';
import { IClientRequestData } from 'services/api/client';
import { ICountry } from 'services/api/country';
import { ICity } from 'services/api/city';
import { IMunicipality } from 'services/api/municipality';

export interface IState {
  country: {
    data: {
      countries: Array<ICountry>;
      defaultCountry: number;
    };
    status: StateStatus | null;
  };
  city: {
    data: Array<ICity>;
    status: StateStatus | null;
  };
  municipality: {
    data: Array<IMunicipality>;
    status: StateStatus | null;
  };
  location: {
    data: any | null;
    status: StateStatus | null;
  };
  updateLocation: {
    status: StateStatus | null;
  };
}

const initialState: IState = {
  country: {
    data: {
      countries: [],
      defaultCountry: 0,
    },
    status: null,
  },
  city: {
    data: [],
    status: null,
  },
  municipality: {
    data: [],
    status: null,
  },
  location: {
    data: null,
    status: null,
  },
  updateLocation: {
    status: null,
  },
};

const SingleClientLocationReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_COUNTRY:
      return {
        ...state,
        country: {
          ...state.country,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CITY:
      return {
        ...state,
        city: {
          ...state.city,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_MUNICIPALITY:
      return {
        ...state,
        municipality: {
          ...state.municipality,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_LOCATON:
      return {
        ...state,
        location: {
          ...state.location,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPDATE_LOCATON:
      return {
        ...state,
        updateLocation: {
          ...state.updateLocation,
          status: action.status || null,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default SingleClientLocationReducer;
